module.exports = __webpack_public_path__ + "static/media/icon-filter.8ad48f1e.svg";